import { createVNode as t, mergeProps as s } from "vue";
import i from "../node_modules/@pf-ui/pf-icon-svg/es/asn/FoldersopeningTwoTone.js";
import p from "../components/PfIcon.js";
const o = (e, r) => {
  const n = {
    ...e,
    ...r.attrs
  };
  return t(p, s(n, {
    icon: i
  }), null);
};
o.displayName = "FoldersopeningTwoTone";
o.inheritAttrs = !1;
export {
  o as default
};
